<template>
  <div class="flex flex-col w-full  ">
    <div class="w-full pl-3 mt-2" v-if="item.is_notulen">
      <div class="font-bold text-warning">#NOTULEN</div>
    </div>
    <div
      class="flex rounded w-full p-3"
      :class="{ 'bg-blue-lightest': newComment }"
    >
      <div>
        <vs-avatar></vs-avatar>
      </div>
      <div class="flex flex-col ml-3 flex-1">
        <div class="w-full flex">
          <div class="flex flex-col flex-1">
            <div class="font-bold username">{{ item.pengguna.nama }}</div>
            <vx-tooltip
              :text="
                `${$options.filters.indonesian_date_time(item.created_at)}`
              "
              position="top"
            >
              <time class="mr-3 comment-datetime">{{
                item.created_at | indonesian_from_now
              }}</time>
            </vx-tooltip>
          </div>
          <div>
            <vs-dropdown>
              <vs-icon
                color="grey"
                size="small"
                icon-pack="feather"
                icon="icon-more-horizontal"
                class="cursor-pointer p-3"
              ></vs-icon>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  class="p-2"
                  style="min-width:200px"
                  @click="toggleNotulen"
                >
                  {{
                    item.is_notulen
                      ? "Hapus Label Notulen"
                      : "Tandai Sebagai Notulen"
                  }}
                </vs-dropdown-item>
                <!-- TODO : next feature -->
                <!-- <vs-dropdown-item class="p-2" style="min-width:200px" divider>
                  Simpan Favorit
                </vs-dropdown-item> -->
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <div class="w-full mt-2" v-html="item.komentar"></div>
        <div class="w-full flex mt-1 text-grey-400">
          <div class="flex flex-1">
            <div class="mr-3 cursor-pointer" @click="toggleShowUserLikes(true)">
              {{ item.sukaCount }} suka
            </div>
          </div>
          <div class="flex ">
            <div
              class="mr-3 font-semibold text-grey-100 cursor-pointer "
              v-if="loadingLike"
            >
              mengirim
            </div>
            <div
              class="mr-3 font-semibold cursor-pointer "
              v-else
              @click="toggleLike"
            >
              {{ item.disukai.length > 0 ? "Tidak Suka" : "Suka" }}
            </div>

            <div
              class="mr-3 font-semibold cursor-pointer "
              v-if="reply"
              @click="toggleReply"
            >
              Balas
            </div>
          </div>
        </div>
        <div class="flex mt-3 replies-wrapper" v-if="item.balasanCount > 0">
          <div class="flex items-center mr-3">
            <hr class="w-10" style="border-color:#ddd" />
          </div>
          <div
            class="cursor-pointer text-show-replies text-grey"
            @click="toggleBalasan(true)"
            v-if="!showReplies"
          >
            Lihat {{ item.balasanCount }} Balasan
          </div>
          <div
            class="cursor-pointer text-hidden-replies"
            @click="toggleBalasan(false)"
            v-else
          >
            Sembunyikan Balasan
          </div>
        </div>
        <div class="flex flex-col w-full pt-2" v-if="showReplies">
          <CommentItem
            v-for="(data, index) in item.balasan"
            :key="index"
            :item="data"
            :reply="false"
          />
        </div>
        <div class="flex flex-col w-full pt-2" v-if="showReplyInput">
          <CommentInput
            :input="inputData"
            @submitComment="submitComment"
            :parentComment="item"
            :commentableData="commentableData"
          />
        </div>
      </div>
      <ModalLikes
        :active="showUserLikes"
        :likes="item.suka"
        @toggleActive="toggleShowUserLikes"
      ></ModalLikes>
    </div>
    <vs-divider></vs-divider>
  </div>
</template>

<script>
import CommentItem from "./CommentItem.vue";
import CommentInput from "./CommentInput.vue";
import ModalLikes from "./ModalLikes.vue";

import { CREATE_SUKA, DELETE_SUKA } from "@/query/suka";
import { UPDATE_KOMENTAR } from "@/query/komentar";

export default {
  name: "CommentItem",
  components: {
    CommentItem,
    CommentInput,
    ModalLikes
  },
  props: {
    item: {
      type: Object
    },
    commentableData: {
      type: Object
    },
    reply: {
      type: Boolean,
      default: true
    },
    newComment: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showReplies: false,
      showReplyInput: false,
      showUserLikes: false,
      loadingLike: false,
      newReplies: []
    };
  },
  methods: {
    toggleBalasan(bol) {
      this.newReplies = [];
      this.showReplies = bol;
    },
    toggleReply() {
      this.showReplyInput = !this.showReplyInput;
    },
    submitComment(data) {
      const replyData = [...this.item.balasan, { ...data }];
      this.newReplies = [{ ...data }];

      this.item.balasanCount = replyData.length;
      this.item.balasan = replyData;
    },
    toggleShowUserLikes(bol) {
      this.showUserLikes = bol;
    },
    toggleNotulen() {
      const is_notulen = !this.item.is_notulen; // toggle is_notulen
      this.$emit("setNotulen", {
        commentId: this.item.id,
        is_notulen: is_notulen
      });
      this.setNotulen();
    },
    async setNotulen() {
      this.$apollo
        .mutate({
          mutation: UPDATE_KOMENTAR,
          variables: {
            id: this.item.id,
            input: {
              is_notulen: this.item.is_notulen ? 1 : 0
            }
          }
        })
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Sukses",
            text: this.item.is_notulen
              ? "Komentar ditandai sebagai notulen"
              : "Label notulen telah dihapus"
          });
        });
    },
    async toggleLike() {
      const liked = this.item.disukai.length > 0 ? true : false;
      this.loadingLike = true;
      if (liked) await this.setUnlike();
      else await this.setLike();
    },
    async setLike() {
      this.item.sukaCount++;
      this.item.disukai = [
        {
          id: 0
        }
      ];
      await this.sendLike();
    },
    async setUnlike() {
      const sukaId = this.item.disukai[0].id;
      this.item.sukaCount--;
      this.item.disukai = [];
      await this.sendUnlike(sukaId);
    },
    async sendLike() {
      await this.$apollo
        .mutate({
          mutation: CREATE_SUKA,
          variables: {
            ...this.sukaable
          }
        })
        .then(data => {
          this.item.disukai = [{ ...data.data.sukaCreate }];
          this.item.suka = [...this.item.suka, { ...data.data.sukaCreate }];
          this.loadingLike = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    async sendUnlike(sukaId) {
      await this.$apollo
        .mutate({
          mutation: DELETE_SUKA,
          variables: {
            id: sukaId
          }
        })
        .then(() => {
          this.item.disukai = [];
          this.item.suka = this.filterSukaById(sukaId);
          this.loadingLike = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    filterSukaById(sukaId) {
      return this.item.suka.filter(item => {
        return item.id != sukaId;
      });
    }
  },
  computed: {
    user() {
      return this.$sanctum.getUser();
    },
    sukaable() {
      return {
        input: {
          sukaable_id: this.item.id,
          sukaable_type: "App\\Models\\Komentar",
          pengguna_id: this.user.id
        }
      };
    },
    inputData() {
      return {
        komentarable_id: this.commentableData.id,
        komentarable_type: this.commentableData.type,
        pengguna_id: this.user.id,
        komentar_id: this.item.id
      };
    }
  }
};
</script>

<style>
.fade-in-enter-active {
  transition: all 2s ease;
}

.fade-in-leave-active {
  transition: all 2s ease;
}

.fade-in-enter,
.fade-in-leave-to {
  position: absolute; /* add for smooth transition between elements */
  opacity: 0;
}
</style>
